import Swiper from "swiper";

export const SwiperDepoimentos = () => {

	const sliders = document.querySelectorAll(".swiper-depoimentos");
	let i = 0;

	sliders.forEach((slider) => {

		const swiper = new Swiper(slider, {
			// loop: true,
			speed: 1200,
			spaceBetween: 80,
			slidesPerView: 1,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				1440: {
					slidesPerView: 2,
				},
			},
		});


		const prevBtn = document.getElementById("swiper-depoimentos-prev-" + i);
		const nextBtn = document.getElementById("swiper-depoimentos-next-" + i);

		// // Add disabled ao btn quando preciso
		const updateNavButtons = () => {
			if (swiper.isBeginning) {
				prevBtn.disabled = true;
			} else {
				prevBtn.disabled = false;
			}

			if (swiper.isEnd) {
				nextBtn.disabled = true;
			} else {
				nextBtn.disabled = false;
			}
		};

		prevBtn.addEventListener("click", () => {
			swiper.slidePrev();
			updateNavButtons();
		});

		nextBtn.addEventListener("click", () => {
			swiper.slideNext();
			updateNavButtons();
		});

		updateNavButtons();

		i++;
	});

};